import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=71ba7108&scoped=true"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba7108",
  null
  
)

export default component.exports